<template>
  <v-container id="attendance-list">
    <v-btn
      type="button"
      color="primary"
      text
      style="margin-left: 10px"
      @click="goBack()"
    >
      Voltar
    </v-btn>
    <v-card v-for="tab in tabs" :key="tab.id" class="rounded-0 bg-light inside">
      <div v-if="tabName === tab.id" class="mb-6">
        <component v-bind:is="dinamicyComponent(tab.component)"></component>
      </div>
    </v-card>
  </v-container>
</template>
<script>
const tabsComponent = {
  Atores: () => import("./atores/insert"),
  Vocacao: () => import("./vocacao/insert"),
  Potenciais: () => import("./potencial/insert"),
  Governanca: () => import("./governanca/insert"),
  RecursosFinanceiro: () => import("./recursosFinanceiros/insert"),
  OutrasOportunidades: () => import("./outrasOportunidades/insert"),
  MarcoLegal: () => import("./marcoLegal/insert"),
};

export default {
  data() {
    return {
      tabs: [
        { id: "ator", name: "Atores", component: "Atores" },
        { id: "vocacao", name: "Vocações", component: "Vocacao" },
        { id: "potenciais", name: "Potenciais", component: "Potenciais" },
        { id: "governanca", name: "Governança", component: "Governanca" },
        {
          id: "recurso",
          name: "Recursos Financeiros",
          component: "RecursosFinanceiro",
        },
        {
          id: "outras",
          name: "Outras Oportunidades",
          component: "OutrasOportunidades",
        },
        {
          id: "marco",
          name: "Marco Legal",
          component: "MarcoLegal",
        },
      ],
      payload: {
        municipioId: this.$route.params.id,
      },
      tabName: this.$route.params.tab,
    };
  },

  methods: {
    dinamicyComponent(tab) {
      return tabsComponent[tab];
    },
    goBack() {
      this.$router.push(`/cidade/${this.payload.municipioId}/agenteTerritorial/${this.$route.params.tab}`);
    },
  },
};
</script>
